import React, { Component } from "react"

import Grid from "@material-ui/core/Grid"
import { ThemeProvider } from '@material-ui/core/styles';
import {TextareaAutosize, withStyles} from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"
import Container from "./someCSS/msSMSHandler";

import { Redirect } from "react-router-dom"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";
import {Multiselect} from "multiselect-react-dropdown";




const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      label: {
            direction: "rtl",
            width: "100%",
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },


      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "black",
            },
      },
      btnsearch: {
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },
})
const ms_style ={
      ms_center: { width: "70%", textAlign:"center", margin:'auto', display:'block', height:"200px"},
      ms_text_field : {textAlign:"center", margin:'auto', display:'inline-block', height:"200px"}
    }
const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",

      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },

};



class MySweetGroupSMS extends Component {
      cookies = new Cookies()
      paramsCounter = 0
      regex = new RegExp("^[-a-zA-Z0-9/،?=آ-ی .:_-]+$");
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  smsList : [],
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  smsContent : "",
                  smsActivation: "1",
                  smsName : "",
                  selectedId : -1,
                  optionEmployee : [],
                  selectedOptionEmployee : [],
                  optionAgents : [],
                  selectedOptionAgent : [],
                  optionUser : [],
                  selectedOptionUser : [],
                  messageOnNotFound : "",

            }
      }


      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }


      getAllEmployees = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = [{value:0 , label : "همه کارمندان"}]
                              // var Company1 = [{ value: 0, label: "همه کارمندان " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].employee_mobile,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family  + " "+ arr.data[k].employee_mobile,
                                    })
                              }
                              self.setState(
                                  { optionEmployee: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getAllAgents = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {

                              var Company = [{value:0 , label : "همه نمایندگان"}]

                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].agent_mobile,
                                          label: arr.data[k].agent_name + " " + arr.data[k].agent_family  + " "+ arr.data[k].agent_mobile,
                                    })
                              }
                              self.setState(
                                  { optionAgent: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_agent")

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getAllUsers = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {

                              var Company = [{value:0 , label : "همه کاربران"}]

                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].user_mobile,
                                          label: arr.data[k].user_name + " " + arr.data[k].user_family  + " "+ arr.data[k].user_mobile,
                                    })
                              }
                              self.setState(
                                  { optionUser: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "getAllUsers")

            xhttp.open("POST", `${constants.BASE_URL}/Userlogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      sendSms = ()=>{
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })


                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "sendGroup")
            fd.append("content", this.state.smsContent)
            fd.append("users",  (this.checkIsAllSelect(this.state.selectedOptionUser))? this.extractValues(this.state.optionUser) :this.extractValues(this.state.selectedOptionUser) )
            fd.append("employees", this.extractValues(this.state.selectedOptionEmployee))
            fd.append("agents", this.extractValues(this.state.selectedOptionAgent))

            xhttp.open("POST", `${constants.BASE_URL}/MySweetSMS`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      checkIsAllSelect(arr){
            console.log("check all select", arr)
            if(arr.length > 0)
                  return arr[0].value === 0
            return false
      }
      extractValues(arr){
            let values = []
            for (const arrKey in arr)
                  if(arr[arrKey].value !== 0)
                        values.push(arr[arrKey].value)
            return values
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    /*
                                          SHOULD BE RELACED
                                     */

                                    self.getAllEmployees()
                                    self.getAllAgents()
                                    self.getAllUsers()


                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      onChange = (content) =>{
      }
      render() {
            const self = this

            const { classes } = this.props
            const {
                  redirect,
                  showSnack,
                  snackMode,
                  snackstr,
                  smsContent,

            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (

                  <Container>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            onClose={this.handleClickcloseTasckBar}
                            open={showSnack}
                            autoHideDuration={10000}
                        >
                              <Alert severity={snackMode}>{snackstr}</Alert>
                        </Snackbar>
                        <Grid container style={{padding: "20px"}} spacing={3}>
                              <Grid item xs={3} sm={3}>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                          <Multiselect
                                              style={styleselect}
                                              options={this.state.optionAgent} // Options to display in the dropdown
                                              selectedValues={this.state.selectedOptionAgent} // Preselected value to persist in dropdown
                                              onSelect={e => this.setState({selectedOptionEmployee: e})}
                                              onRemove={e => this.setState({selectedOptionEmployee: e})}
                                              displayValue="label" // Property name to display in the dropdown options
                                              display="chip"
                                              placeholder="انتخاب نماینده"
                                              closeIcon="circle2"
                                          />
                                    </div>
                              </Grid>
                                    <Grid item xs={3} sm={3}>
                                          <div style={{ width: "100%", textAlign: "center" }}>
                                                <Multiselect
                                                    style={styleselect}
                                                    options={this.state.optionEmployee} // Options to display in the dropdown
                                                    selectedValues={this.state.selectedOptionAgent} // Preselected value to persist in dropdown
                                                    onSelect={e => this.setState({selectedOptionAgent: e})}
                                                    onRemove={e => this.setState({selectedOptionAgent: e})}
                                                    displayValue="label" // Property name to display in the dropdown options
                                                    display="chip"
                                                    placeholder="انتخاب کارمند"
                                                    closeIcon="circle2"
                                                />
                                          </div>
                                    </Grid>
                                    <Grid item xs={3} sm={3}>
                                          <div style={{ width: "100%", textAlign: "center" }}>
                                                <Multiselect
                                                    style={styleselect}
                                                    options={this.state.optionUser} // Options to display in the dropdown
                                                    selectedValues={this.state.selectedOptionUser} // Preselected value to persist in dropdown
                                                    onSelect={e => this.setState({selectedOptionUser: e})}
                                                    onRemove={e => this.setState({selectedOptionUser: e})}
                                                    displayValue="label" // Property name to display in the dropdown options
                                                    display="chip"
                                                    placeholder="انتخاب کاربر"
                                                    closeIcon="circle2"
                                                />
                                          </div>
                                    </Grid>

                              <Grid item xs={12}  >
                                    <TextareaAutosize
                                          style={ms_style.ms_center}
                                        placeholder="متن sms"
                                          id={"sms_content"}
                                          value={smsContent}
                                          onChange={e=>this.setState({smsContent: e.target.value})}
                                    />
                              </Grid>

                                  <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                          onClick={()=>this.sendSms()}>
                                        {"ارسال sms"}
                                  </Button>
                        </Grid>
                  </Container>
                  )
            }
      }
}

export default withStyles(styles)(MySweetGroupSMS)
